<template>
  <div id="financeReportTables" class="grid grid-cols-6 lg:gap-x-20">
    <h3 class="heading-3 col-span-6 mb-16">
      {{ i18n(translations.resultsTitle) }}
    </h3>
    <div class="hidden md:col-span-2 md:block lg:col-span-1 lg:block">
      <MetricsTable :metrics="report.metrics" />
    </div>
    <div class="col-span-6 mb-20 md:col-span-4 lg:col-span-2 lg:mb-0">
      <YearTable
        :title="report.thisYearTitle"
        :year-report="report.thisYearReport"
      />
    </div>
    <div class="hidden md:col-span-2 md:block lg:hidden">
      <MetricsTable :metrics="report.metrics" />
    </div>
    <div class="col-span-6 mb-20 md:col-span-4 lg:col-span-2 lg:mb-0">
      <YearTable
        :title="report.lastYearTitle"
        :year-report="report.lastYearReport"
      />
    </div>
    <div class="hidden md:col-span-2 md:block lg:hidden">
      <MetricsTable :metrics="report.metrics" />
    </div>
    <div class="col-span-6 mb-20 md:col-span-4 lg:col-span-1 lg:mb-0">
      <YearOnYearTable :year-on-year-report="report.yearOnYearReport" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { formattedFinancialReport } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/financial-report.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './FinancialReportTables.translations'
import MetricsTable from './components/MetricsTable/MetricsTable.vue'
import YearOnYearTable from './components/YearOnYearTable/YearOnYearTable.vue'
import YearTable from './components/YearTable/YearTable.vue'

defineProps<{
  report: formattedFinancialReport
}>()

const i18n = useI18n()
</script>

<style lang="scss">
/* As the display of this page is unique (four tables aligned in row) we cannot do it without specific SCSS*/
#financeReportTables {
  td > div {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: 100%;
    padding-left: 0px;
    padding-right: 16px;
  }

  td {
    height: 73px !important;
  }

  th > div {
    float: right !important;
  }

  tbody tr:last-child {
    background-color: #f8f9fc;
  }
}
</style>
